import { render, staticRenderFns } from "./Ship.vue?vue&type=template&id=677031ac&scoped=true&"
import script from "./Ship.vue?vue&type=script&lang=js&"
export * from "./Ship.vue?vue&type=script&lang=js&"
import style0 from "./Ship.vue?vue&type=style&index=0&id=677031ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677031ac",
  null
  
)

export default component.exports